<template>
    <div>
        <div class="head-bar">
            <div>
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="_save">添加</el-button>
            </div>
            <el-input v-model="datas.add.controller" placeholder="controller" clearable></el-input>
            <el-input v-model="datas.add.action" placeholder="action" clearable></el-input>
            <el-input v-model="datas.add.kw" placeholder="关键词" clearable></el-input>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column prop="id" label="ID" width="100" sortable="custom"></el-table-column>
            <el-table-column label="名称" width="300">
                <template slot-scope="scope">
                    <input v-model="scope.row.title" @blur="_quick_edit(table, scope.row.id, 'title', scope.row.title)"
                        style="width: 200px !important;">
                </template>
            </el-table-column>
            <el-table-column prop="controller" label="控制器" sortable="custom"></el-table-column>
            <el-table-column prop="action" label="操作" sortable="custom"></el-table-column>
            <el-table-column prop="is_rule" label="是否验证" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_rule" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_rule', scope.row.is_rule)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="is_show" label="是否显示" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_show" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_show', scope.row.is_show)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="is_ign" label="是否忽略" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_ign" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_ign', scope.row.is_ign)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text" @click="_del(scope.row.id)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
            :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
            :total="datas.total">
        </el-pagination>

        <ls-table-data :table="table" @fields="e => { mix_fields = e }"></ls-table-data>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'admin_rule',
            datas: {
                order: {
                    last_time: 'desc'
                }
            }
        };
    },
    created() {
        this._load();
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>